<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="v" class="page" id="pv" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocfm"><a class="xref" href="#/chisites0007#au_note">Author’s Note</a></p>
<p class="tocf"><a class="xref" href="#/chisites0008#urban">Urban Routes, Utopian Pathways</a></p>
<p class="tocpt"><a class="xref" href="#/chisites0009#pt01"><span class="sm">PART</span> <span class="sm">I:</span> <span class="sm">BIRMINGHAM</span></a></p>
<p class="toc"><a class="xref" href="#/chisites0010#ch01">1—Downtown Sounds</a></p>
<p class="toc"><a class="xref" href="#/chisites0011#ch02">2—Industrial School to Territory Band</a></p>
<p class="toc"><a class="xref" href="#/chisites0012#ch03">3—Leadership Dreams</a></p>
<p class="tocpt"><a class="xref" href="#/chisites0013#pt02"><span class="sm">PART</span> <span class="sm">II:</span> <span class="sm">CHICAGO</span></a></p>
<p class="toc"><a class="xref" href="#/chisites0014#ch04">4—South Side Music Scene</a></p>
<p class="toc"><a class="xref" href="#/chisites0015#ch05">5—“Sound So Loud It Will Wake Up the Dead”</a></p>
<p class="toc"><a class="xref" href="#/chisites0016#ch06">6—Utopian Chicago</a></p>
<p class="toc"><a class="xref" href="#/chisites0017#ch07">7—African Space</a></p>
<p class="toc"><a class="xref" href="#/chisites0018#ch08">8—Wonder Inn, 1960</a></p>
<p class="toc"><a class="xref" href="#/chisites0019#line">Lineages/Legacies</a></p>
<p class="tocbmf"><a class="xref" href="#/chisites0020#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chisites0021#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chisites0023#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-sites-0006.vue?6a7eabcc